import { createI18n } from 'vue-i18n'

export default defineNuxtPlugin(async ({ vueApp }) => {
  // create new instance of i18n
  // if we need other languages -> https://vue-i18n.intlify.dev/guide/integrations/nuxt3#localize-your-nuxt-3-application
  const i18n = createI18n({
    legacy: false,
    locale: 'de',
    globalInjection: true,
    fallbackLocale: 'de',
    messages: {
      de,
    },
  })

  vueApp.use(i18n)
})
